const LOCATIONS_WITH_VESSEL_DETAIL_FIELDS = new Set(["FOTT", "VPK"]);

type RadioButtonParams = {
  movementType: string;
  fromLocation: string;
  toLocation: string;
};

export const shouldShowVesselDetailRadioButtons = ({
  movementType,
  fromLocation,
  toLocation,
}: RadioButtonParams): boolean => {
  if (!movementType) return false;

  const isEligibleLocation = (location: string) =>
    LOCATIONS_WITH_VESSEL_DETAIL_FIELDS.has(location);

  return (
    (isEligibleLocation(fromLocation) &&
      (movementType === "BERTH_TO_ANCHORAGE" ||
        movementType === "BERTH_TO_SEA" ||
        movementType === "BERTH_TO_BERTH")) ||
    (isEligibleLocation(toLocation) &&
      (movementType === "SEA_TO_BERTH" ||
        movementType === "ANCHORAGE_TO_BERTH" ||
        movementType === "BERTH_TO_BERTH"))
  );
};
